'use client';

import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useMemo } from 'react';
import { getDetailedDates, getSimpleDate } from '@/functions/datetimeToDisplay';

type Props = {
  imEvent: ImEventDto;
};

export const DetailedDatesRow: React.FC<Props> = ({
  imEvent: { datetimes }
}) => {
  const dateDetails = useMemo(() => getDetailedDates(datetimes), [datetimes]);
  return (
    <TableRow>
      <TableCell>日程</TableCell>
      <TableCell>
        {dateDetails.map((detail, i) => (
          <Box key={`date-detail-${i}`}>{detail}</Box>
        ))}
      </TableCell>
    </TableRow>
  );
};

export const SimpleDatesRow: React.FC<Props> = ({
  imEvent: { startsAt, endsAt }
}) => {
  const dateDetail = useMemo(
    () => getSimpleDate(startsAt, endsAt),
    [startsAt, endsAt]
  );
  return (
    <TableRow>
      <TableCell>期間</TableCell>
      <TableCell>{dateDetail}</TableCell>
    </TableRow>
  );
};
